"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactComponents = require("@ucloud-fe/react-components");

var _index = require("./style/index");

var _excluded = ["icon", "prefix", "onClick", "href", "target", "children"];

var _this = void 0;

/**
 * ProductLayout.ExtraLink
 * @description 产品页头右侧操作区域的链接
 */
var ExtraLink = function ExtraLink(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var icon = _ref.icon,
      prefix = _ref.prefix,
      onClick = _ref.onClick,
      href = _ref.href,
      target = _ref.target,
      children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var renderIcon = function renderIcon() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if (!icon) {
      return null;
    }

    if ((0, _isString2["default"])(icon)) {
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.Icon, {
        className: _index.headerExtraLinkIconCls,
        type: icon,
        prefix: prefix
      });
    }

    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _index.headerExtraLinkIconCls
    }, icon);
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_index.StyledExtraLink, (0, _extends2["default"])({
    onClick: onClick,
    href: href,
    target: target
  }, others), renderIcon(), children);
}.bind(void 0);

ExtraLink.propTypes = {
  /** 图标，传入string时为图标类型，也可直接传入图标组件 */
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** icon类名前缀，当icon为图标组件时，会被忽略*/
  prefix: _propTypes["default"].string,

  /** 点击时的回调 */
  onClick: _propTypes["default"].func,

  /** 点击跳转的地址，指定此属性，则行为与a链接一致 */
  href: _propTypes["default"].string,

  /** 相当于a链接的target属性，href存在时生效 */
  target: _propTypes["default"].string,

  /** @ignore */
  className: _propTypes["default"].string,

  /** @ignore */
  style: _propTypes["default"].object,

  /** @ignore */
  children: _propTypes["default"].node
};
ExtraLink.defaultProps = {};
var _default = ExtraLink;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ProductLayout/ExtraLink.js
// module id = 2130
// module chunks = 6 7 17 18